import api from './client';
import { definirAccessToken, temSessao } from './session';

/**
 * A restauração da sessão no boot, feita uma vez só.
 *
 * Dois pontos precisam saber se há sessão antes de decidir qualquer coisa: o
 * guard do router (para não mandar ao login quem já entrou) e o `autoLogin` do
 * `App.vue` (para carregar o jogador). Os dois disparam praticamente juntos.
 *
 * Sem esta memoização seriam duas tentativas de refresh simultâneas — e como o
 * refresh do V2 é **rotativo**, a segunda chegaria com um token que a primeira
 * já invalidou. O backend trata reuso de refresh como sessão comprometida e
 * derruba a família inteira: o jogador seria deslogado por abrir o jogo.
 *
 * Também resolve a corrida: o guard espera a mesma promessa, em vez de olhar um
 * cookie e decidir antes de a resposta chegar.
 */
let tentativa = null;

export function restaurarSessao() {
  if (!tentativa) {
    tentativa = (async () => {
      if (temSessao()) return true;
      try {
        // Só o cookie httpOnly de refresh pode nos salvar aqui — e ele é
        // invisível para este código, então a única forma de saber se existe é
        // perguntar ao servidor.
        const { data } = await api.post('/api/auth/refresh');
        definirAccessToken(data.accessToken);
        return true;
      } catch {
        // Sem sessão. Não é erro: é visitante.
        return false;
      }
    })();
  }
  return tentativa;
}

/** Esquece a tentativa anterior. Chamado no logout, para o próximo boot tentar de novo. */
export function esquecerRestauracao() {
  tentativa = null;
}
